import { useMemo } from "react";

import { useBandContext, usePermissionsContext } from "Bands/contexts";
import { EditBlock as Component, IEditBlockItem } from "shared/components";
import { ILocalStorageKey } from "shared/types";
import { copy } from "shared/assets";
import {
  Band,
  Megaphone,
  Stage,
  User,
  UserMultiple,
  Edit,
} from "shared/assets/icons";
import { BAND_PATHS } from "Bands/router";
import { useBandRoute } from "Bands/utils";

const editBlockCopy = copy.calendar.editBlock;

const MAIN_PAGE_ID = "0";

export const EditBlock = () => {
  const { userCanAddEvent, userCanManageBand, userCanManageMembers } =
    usePermissionsContext();
  const { bandId, openCreateBandModal } = useBandContext();
  const { getPath } = useBandRoute();

  const items = useMemo(() => {
    if (bandId) {
      let bandItems = [] as IEditBlockItem[];

      bandItems.push({
        icon: Stage,
        label: editBlockCopy.band.event,
        to: getPath(BAND_PATHS.CREATE_BAND_EVENT),
      });

      bandItems.push({
        icon: UserMultiple,
        label: editBlockCopy.band.members,
        to: getPath(BAND_PATHS.CREATE_MEMBER),
      });

      bandItems.push({
        icon: Edit,
        label: editBlockCopy.band.settings,
        to: getPath(BAND_PATHS.BAND_SETTINGS),
      });

      return bandItems;
    }

    return [
      {
        icon: Band,
        label: editBlockCopy.main.band,
        handleClick: openCreateBandModal,
      },
      {
        icon: User,
        label: editBlockCopy.main.profile,
        to: BAND_PATHS.PROFILE,
      },
    ];
  }, [bandId, getPath, openCreateBandModal]);

  const hasAllPermissions = useMemo(
    () => userCanAddEvent && userCanManageMembers && userCanManageBand,
    [userCanAddEvent, userCanManageBand, userCanManageMembers]
  );

  if (!items.length) return null;

  // only show band edit block if user has all needed permissions
  if (bandId && !hasAllPermissions) return null;

  return (
    <Component
      items={items}
      id={bandId || MAIN_PAGE_ID}
      localStorageKey={ILocalStorageKey.hideBandEdit}
      cardIcon={Megaphone}
      cardTitle={editBlockCopy.title}
    />
  );
};
